import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const Stat = ({ label, value, tone, id }) => (
  <div className="bg-white border border-slate-200 rounded-xl p-4" data-testid={`beta-stat-${id}`}>
    <p className="text-xs uppercase tracking-wide text-slate-500">{label}</p>
    <p className={`text-3xl font-bold mt-1 ${tone || 'text-slate-900'}`}>{value ?? '—'}</p>
  </div>
);

export const BetaOverview = ({ o, onSaveSpots }) => {
  const [spots, setSpots] = useState('');
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-3">
        <Stat id="spots" label="Spots used" value={o && `${o.used} / ${o.spots}`} />
        <Stat id="left" label="Spots left" value={o?.left} tone="text-emerald-700" />
        <Stat id="active" label="In beta now" value={o?.active} tone="text-sky-700" />
        <Stat id="ending" label="Ending ≤14 days" value={o?.endingSoon} tone="text-amber-700" />
        <Stat id="ended" label="Ended" value={o?.ended} tone="text-rose-700" />
        <Stat id="lifetime" label="Free for life" value={o?.lifetime} tone="text-emerald-700" />
        <Stat id="testimonials" label="Testimonials / photos" value={o && `${o.testimonials} / ${o.photos}`} />
        <Stat id="reviews" label="5-star reviews" value={o?.reviews} />
      </div>
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <span className="text-slate-600">Number of beta spots:</span>
        <Input type="number" min={1} max={500} value={spots} placeholder={String(o?.spots ?? '')} onChange={(e) => setSpots(e.target.value)}
          className="w-24 h-9" data-testid="beta-spots-input" />
        <Button size="sm" variant="outline" disabled={!spots} onClick={() => { onSaveSpots(Number(spots)); setSpots(''); }} data-testid="beta-spots-save-btn">Save</Button>
        <span className="text-slate-400">Shown on app.practcom.com/beta</span>
      </div>
    </div>
  );
};
